export function LoadingSpinner() {
  return (
    <div className="terminal-loading">
      LOADING
    </div>
  );
}


